import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { TooltipStyles, applyTooltipCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: '[flxTooltipStyle]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxTooltipStyleDirective {
  componentStyle = input<{
    style: TooltipStyles
  }>(undefined, { alias: 'flxTooltipStyle' })

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyTooltipCustomStyles(
        this.componentStyle()?.style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }
}
